import React from 'react';
import {
  Dialog,
  DialogContent,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
// HOOKS
import { useAppSelector } from '../../../../hooks';
// STORE
import { getSubmissionState } from '../../../../store/SubmissionSlice';
// HELPERS
import { getSubjectColor } from '../../../../helper';
// CONSTANTS
import { TP_COLORS } from '../../../../constants';

interface QuizTimeTakenModalProps {
  open: boolean;
  onClose: () => void;
}

// DATA
const getFormatedTime = (seconds = 0) => {
  const val = Math.abs(seconds);

  const _hours = Math.floor(val / 3600)
    .toString()
    .padStart(2, '0');
  const _minutes = Math.floor((val % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const _seconds = Math.floor((val % 3600) % 60)
    .toString()
    .padStart(2, '0');

  return `${_hours}: ${_minutes}: ${_seconds}`;
};

const QuizTimeTakenModal: React.FC<QuizTimeTakenModalProps> = ({
  open,
  onClose,
}) => {
  // HOOKS
  const { submission } = useAppSelector(getSubmissionState);

  let allocatedTime = '00: 00: 00';
  let timeSpent = '00: 00: 00';
  let difference = '00: 00: 00';

  let isExpired = false;

  if (submission && submission.totalScore) {
    const _allocatedSeconds = submission.totalScore
      ? submission.totalScore * 60
      : 0;
    allocatedTime = getFormatedTime(_allocatedSeconds);

    if (submission.timerStart && submission.timerEnd) {
      const _spentSeconds = Math.floor(
        (submission.timerEnd - submission.timerStart) / 1000
      );
      timeSpent = getFormatedTime(_spentSeconds);
      difference = getFormatedTime(_allocatedSeconds - _spentSeconds);

      isExpired = _allocatedSeconds < _spentSeconds;
    }
  }

  // RENDER
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Stack>
          <div style={{ marginBottom: '15px' }}>
            <Card elevation={0} style={{ background: getSubjectColor('') }}>
              <CardContent style={{ paddingBottom: '16px' }}>
                <Typography variant="h6" color={TP_COLORS.white}>
                  Time taken for this Quiz
                </Typography>
              </CardContent>
            </Card>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <Typography color="secondary">
              Allocated time - {allocatedTime}
            </Typography>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <Typography color="secondary">Time spent - {timeSpent}</Typography>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <Typography color="secondary">
              Difference -{' '}
              <Typography
                component="span"
                color={isExpired ? 'error.main' : 'success.main'}
              >
                {difference}
              </Typography>
            </Typography>
          </div>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default QuizTimeTakenModal;
